module.exports = __webpack_public_path__ + "img/rasta.7839c847.jpg";